// extracted by mini-css-extract-plugin
export var fadeIn = "_l1-1";
export var modalContent = "_l1-3";
export var overlay = "_l1-0";
export var popoverContent = "_l1-2";
export var results = "_l1-5";
export var searchInputWrapper = "_l1-4";